import React, { Component } from 'react'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'
import Casetta1 from '../../../assets/images/strutture/extra/casetta/altre-strutture-casette-noleggiocampi.jpg'
import Casetta2 from '../../../assets/images/strutture/extra/casetta/casetta-3x2-checkin-campo-accessori-noleggiocampi.jpg'
import Casetta3 from '../../../assets/images/strutture/extra/casetta/dettaglio-tetto-casetta-di-legno-noleggiocampi.jpg'
import {
  Wrapper,
  Header,
  Title,
  Icon,
  CheckMark,
  Content,
  Left,
  Right,
  Para,
  Table,
  Button,
  Image,
  Thumbnails,
  Thumb,
  Section,
  UList,
  MobileContent,
  TableWrapper,
  MobileBottom,
  Price,
  Heading
} from './InfoCommon'
import { casetta } from '../../Pages/Strutture/Extra'

const tableContent = [
  ['CALCETTO', 'x', 'x', 'x'],
  ['BASKET', 'x', 'x', 'x'],
  ['BEACH VOLLEY', 'x', 'x', 'x']
]

const Heading3 = styled.h3`
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  font-size: 24px;
  padding: 0.5rem 0;

  @media ${device.tablet} {
    font-size: 1.875vw 0;
  }
`

const Text = styled.div`
  font-size: 16px;
  line-height: 1.1em;

  @media ${device.tablet} {
    font-size: 12px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }

  @media ${device.laptopL} {
    font-size: 15px;
  }

  @media ${device.desktop} {
    font-size: 17px;
  }
`

const Description = () => {
  return (
    <Section>
      <Para>
        {casetta.description.split(';').map(line => <span>{line} <br /></span>)}
      </Para>
      <Heading3>INTERNI</Heading3>
      <Text>
        <span>Gli interni della casetta sono personalizzabili e customizzabili a seconda delle diverse esigenze</span><br />
        <span>È possibile installare mensole, cubotti, tavolini e TV che possano migliorare l’organizzazione interna dell’ambiente.</span>
      </Text>
    </Section>
  )
}

const TableInstance = () => {
  return (
    <React.Fragment>
      <Heading>DISPONIBILE PER</Heading>
      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <th />
              <th>BASE</th>
              <th>PRO</th>
              <th>TOP</th>
            </tr>
          </thead>
          <tbody>
            {tableContent.map((row, i) => {
              return (
                <tr key={i}>
                  {row.map((data, i) => <td key={i} style={{ textAlign: data === 'x' ? 'center' : 'left' }}>{data === 'x' ? <CheckMark /> : data}</td>)}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </TableWrapper>
    </React.Fragment>
  )
}

const ListInstance = () => {
  return (
    <Section>
      <Heading>SCHEDA TECNICA</Heading>
      <UList>
        {casetta.technical.map((item, i) => <li key={i}>{item}</li>)}
      </UList>
    </Section>
  )
}

class Slider extends Component {
  state = {
    activeImage: Casetta1,
    images: [Casetta1, Casetta2, Casetta3]
  }

  handleImageChange (image) {
    this.setState({ activeImage: image })
  }

  render () {
    return (
      <React.Fragment>
        <Image src={this.state.activeImage} alt='Something' />
        <Thumbnails imgCount={this.state.images.length}>
          {this.state.images.map(image => <Thumb onClick={this.handleImageChange.bind(this, image)} src={image} />)}
        </Thumbnails>
      </React.Fragment>
    )
  }
}

class Casetta extends Component {
  closeIconClick () {
    this.props.closeModal()
  }

  render () {
    return (
      <Wrapper>
        <Header>
          <Icon fill='#fff' onClick={this.closeIconClick.bind(this)} />
          <Title>
            CASETTA CHECK-IN
          </Title>
        </Header>
        <Content>
          <Left>
            {/* Image Slider */}
            <Slider />

            {/* Table */}
            <TableInstance />

            {/* Price */}
            <Price>A PARTIRE DA <span style={{ color: '#fca317' }}>1220 €</span></Price>
          </Left>
          <Right>
            <div>
              {/* Description of component */}
              <Description />

              {/* Technical info */}
              <ListInstance />
            </div>

            <Button onClick={this.closeIconClick.bind(this)}>CHIUDI</Button>
          </Right>
        </Content>
        {/* Content on mobile */}
        <MobileContent>
          {/* Description of component */}
          <Description />

          {/* Image Slider */}
          <Slider />

          {/* Technical info */}
          <ListInstance />

          {/* Table */}
          <TableInstance />

          <MobileBottom>
            <Price>A PARTIRE DA <span style={{ color: '#fca317' }}>1220 €</span></Price>
            <Button onClick={this.closeIconClick.bind(this)}>CHIUDI</Button>
          </MobileBottom>
        </MobileContent>
      </Wrapper>
    )
  }
}

export default Casetta



// WEBPACK FOOTER //
// ./src/components/Helpers/Info/Casetta.js